const STORAGE_PREFIX = 'executorRegistrationProgress:'
const FALLBACK_USER_KEY = 'current'
const PROGRESS_TTL = 30 * 24 * 60 * 60 * 1000

export const FULL_REGISTRATION_ROUTES = [
  '/full_registration_step0',
  '/full_registration_step0_1',
  '/full_registration_step1',
  '/full_registration_step2',
  '/full_registration_step3',
  '/full_registration_step4',
  '/full_registration_step5',
  '/full_registration_step6',
]

const getTokenUserKey = () => {
  const token = localStorage.getItem('accessToken')
  if (!token) return FALLBACK_USER_KEY

  try {
    const payloadPart = token.split('.')[1]
    if (!payloadPart) return FALLBACK_USER_KEY

    const normalized = payloadPart.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=')
    const payload = JSON.parse(atob(padded))

    return String(
      payload.sub ||
      payload.userId ||
      payload.executorId ||
      payload.email ||
      payload.phone ||
      FALLBACK_USER_KEY
    )
  } catch {
    return FALLBACK_USER_KEY
  }
}

const getStorageKey = () => `${STORAGE_PREFIX}${getTokenUserKey()}`

export const saveExecutorRegistrationProgress = (path) => {
  const stepIndex = FULL_REGISTRATION_ROUTES.indexOf(path)
  if (stepIndex < 0) return

  const storageKey = getStorageKey()

  try {
    const saved = JSON.parse(localStorage.getItem(storageKey))
    const savedStepIndex = FULL_REGISTRATION_ROUTES.indexOf(saved?.path)
    const savedIsCurrent = saved?.updatedAt && Date.now() - saved.updatedAt <= PROGRESS_TTL

    if (savedIsCurrent && savedStepIndex > stepIndex) return
  } catch {
    // Повреждённая запись будет заменена новой.
  }

  localStorage.setItem(storageKey, JSON.stringify({
    version: 1,
    path,
    stepIndex,
    updatedAt: Date.now(),
  }))
}

export const getExecutorRegistrationProgress = () => {
  const storageKey = getStorageKey()

  try {
    const progress = JSON.parse(localStorage.getItem(storageKey))
    const isExpired = !progress?.updatedAt || Date.now() - progress.updatedAt > PROGRESS_TTL
    const stepIndex = FULL_REGISTRATION_ROUTES.indexOf(progress?.path)

    if (isExpired || stepIndex < 0) {
      localStorage.removeItem(storageKey)
      return null
    }

    return { ...progress, stepIndex }
  } catch {
    localStorage.removeItem(storageKey)
    return null
  }
}

export const getSavedExecutorRegistrationPath = () =>
  getExecutorRegistrationProgress()?.path || null

export const clearExecutorRegistrationProgress = () => {
  localStorage.removeItem(getStorageKey())
}
